import { useQuery } from '@tanstack/react-query'
import { useCustomerId } from 'features/customers/hooks/useCustomerId'

import { get } from 'utils/http'

export const useCustomerUsers = (search = '') => {
  const customerId = useCustomerId()
  return useQuery({
    queryKey: ['customer', customerId, 'users', search],
    queryFn: () => get(`/management/customers/${customerId}/users`, { query: { search } }),
  })
}
